import React from 'react';
import { 
  Box, 
  Typography, 
  List, 
  ListItem, 
  ListItemAvatar, 
  Avatar, 
  ListItemText, 
  Divider, 
  Paper
} from '@mui/material';
import { 
  CheckCircle,
  Store as StoreIcon,
  Payment,
  Warning,
  Info
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

// Mock notification data
const notifications = [
  {
    id: 1,
    type: 'checkin',
    title: 'Check-in Approved',
    message: 'Your check-in at SuperMart has been approved.',
    time: '2 hours ago',
    read: false,
    icon: <CheckCircle color="success" />
  },
  {
    id: 2,
    type: 'payment',
    title: 'Payment Received',
    message: 'You have received a payment of $25.00 for your recent check-ins.',
    time: '1 day ago',
    read: false,
    icon: <Payment color="primary" />
  },
  {
    id: 3,
    type: 'reminder',
    title: 'Check-in Reminder',
    message: 'You have 3 pending check-ins to complete this week.',
    time: '2 days ago',
    read: true,
    icon: <Warning color="warning" />
  },
  {
    id: 4,
    type: 'update',
    title: 'App Update',
    message: 'A new version of the app is available. Update now for new features.',
    time: '3 days ago',
    read: true,
    icon: <Info color="info" />
  },
];

const Notifications: React.FC = () => {
  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 600, mb: 3 }}>
        Notifications
      </Typography>

      <Paper sx={{ overflow: 'hidden', mb: 3 }}>
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {notifications.map((notification, index) => (
            <React.Fragment key={notification.id}>
              <ListItem 
                alignItems="flex-start"
                sx={{
                  bgcolor: notification.read ? 'transparent' : 'action.hover',
                  '&:hover': {
                    bgcolor: 'action.hover',
                  },
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'transparent', color: 'inherit' }}>
                    {notification.icon}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        color="text.primary"
                        sx={{ fontWeight: notification.read ? 400 : 600 }}
                      >
                        {notification.title}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ ml: 2 }}
                      >
                        {notification.time}
                      </Typography>
                    </Box>
                  }
                  secondary={
                    <Typography
                      component="span"
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                      }}
                    >
                      {notification.message}
                    </Typography>
                  }
                />
              </ListItem>
              {index < notifications.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default Notifications;
